<div class="flex flex-col">

<!-- Modal header -->
<div *ngIf="!isComponent" class="sticky flex justify-between border-b rounded-t dark:border-gray-600"
[ngClass]="{'p-2 items-center': data?.data?.module === 'createRoute', 'p-4 items-start': data?.data?.module !== 'createRoute'}"
>
    <h6 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{data?.data?.header?.titleDisplayKey | translate}}
    </h6>
    <span (click)="closeModal()" mat-dialog-close class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
    </span>
</div>
<!-- Modal body -->
<div [ngClass]="{'p-3': data?.data?.module === 'createRoute', 'p-6': data?.data?.module !== 'createRoute' && !isComponent, 'py-4': isComponent}"
>
    <div class="w-full grid" [ngClass]="{'grid-cols-1 map-container-height zuper-scrollbar overflow-auto': data?.data?.module === 'createRoute', 'h-full grid-cols-2': data?.data?.module !== 'createRoute'}" *ngIf="showFields">
        <div class="col-span-1 pr-3 flex items-center justify-center">
            <div *ngIf="showPreview" class="h-full w-full">
                <app-map-picker [standalone]="true" [module]="this.data?.data?.module" [geoCoords]="mapOptions?.coords" (addressChange)="addressChanged($event)"></app-map-picker>
            </div>
            <!-- <div class="p-6 flex flex-col items-center justify-center" *ngIf="!showPreview">
                <img src="/assets/images/svgs/location_placeholder.svg" class="h-32" alt="">
                <p class="py-1">{{"placeholder.choose_address_pick_from_map" | translate}}</p>
            </div> -->
        </div>
        <div class="col-span-1">
            <form [formGroup]="!isComponent ? this.data?.data?.formGroup : formGroup">
                <contact-info 
                    [fields]="addressFields" 
                    [addressFormGroupName]="!isComponent ? this.data?.data?.formGroupName : formGroupName" 
                    [allowMulitpleEmails]="allowMultipleEmails"
                    [optionalAddress]="(this.data?.data?.formGroupName === 'end_location' && this.data?.data?.module === 'createRoute' ? true : false) || optionalAddress"
                    >
                </contact-info>
            </form>
        </div>
    </div>
    
</div>
<!-- Modal footer -->
<div *ngIf="!isComponent" class="flex justify-end items-center space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600"
[ngClass]="{'p-2': data?.data?.module === 'createRoute', 'p-6': data?.data?.module !== 'createRoute'}"
>
    <button (click)="closeModal()" type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:outline-none rounded-lg border border-gray-200 text-base font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">{{"close.text" | translate}}</button>
    <button (click)="saveAddress()" type="button" class="text-white bg-primary font-medium rounded-lg text-base px-5 py-2.5 text-center">{{"add.text" | translate}}</button>
</div>

</div>